import { ISourceDataStore } from '@stores/sourceDataStore';
import React, { useState } from 'react';
import { inject, observer } from 'mobx-react';
import Modal from '@ui-library/modal/custom';
import { ScheduleTypes } from '@components/sources/source/cloudSource/cloudSourceSchedule/scheduleTypes';
import ScheduleSettingsInfo from '@components/sources/source/cloudSource/cloudSourceSchedule/scheduleSettingsInfo';
import { ScheduleI } from '@components/sources/source/cloudSource/cloudSourceSchedule/schedules';
import { NewLabel } from '@ui-library/typography';
import { getScheduleDetails } from '@components/sources/visualizer/mappingScreens/sourceUtil';
import ScheduleSettings from '@components/sources/source/cloudSource/cloudSourceSchedule/scheduleSettings';

interface OwnProps {
  onCancel: () => void;
  sourceDataStore?: ISourceDataStore;
}

type Props = OwnProps;

const SyncSchedulePopup = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const { sourceDataStore: source, onCancel } = props;
  const defaultSchedule: ScheduleI = { ...source?.config?.schedule } || {};

  // handling backward compatibility where every =0 means manual and every!=0 means basic
  if (!defaultSchedule.type) {
    defaultSchedule.type = defaultSchedule.every ? ScheduleTypes.Basic : ScheduleTypes.Manual;
  }
  const [scheduleState, setScheduleState] = useState<ScheduleI>(defaultSchedule);
  const [isInvalid, setInvalid] = useState(false);
  const handleSave = async () => {
    try {
      setLoading(true);
      const updatedConfig = { schedule: scheduleState };
      await source?.updateConfig(updatedConfig);
      props.onCancel();
    } catch (e) {
      setLoading(false);
    }
  };
  const onChangeScheduleSelect = (v: string) => {
    // TODO: Move this functionality to rudder-sources
    if (v === ScheduleTypes.Manual) {
      setScheduleState({ type: v, every: 0, unit: 'minutes' });
    } else {
      setScheduleState({ type: v });
    }
    setInvalid(false);
  };

  const { subHeaderText } = getScheduleDetails(scheduleState);
  const scheduleType = scheduleState.type;
  const onChangeSchedule = (schedule: ScheduleI) => {
    setScheduleState({ type: scheduleState.type, ...schedule });
  };

  return (
    <Modal
      size="md"
      title={
        <div className="header_info">
          <div className="main_text">
            Sync Schedule
            <ScheduleSettingsInfo />
          </div>
          <div className="sub_text">{subHeaderText}</div>
        </div>
      }
      onClose={onCancel}
      content={
        <>
          <NewLabel className="m-b-xs">Schedule Type</NewLabel>
          <ScheduleSettings
            scheduleType={scheduleType}
            onScheduleTypeChange={onChangeScheduleSelect}
            value={scheduleState}
            onRunSettingsChange={onChangeSchedule}
            setInvalid={setInvalid}
          />
        </>
      }
      saveLabel="Save"
      onSave={handleSave}
      loading={loading}
      isSaveDisabled={isInvalid}
    />
  );
};

export default inject('sourceDataStore')(observer(SyncSchedulePopup));
